import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DatePickerModule, DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { VacationRequestsPopupComponent } from './vacation-requests-grid/vacation-requests-popup/vacation-requests-popup.component';
import { AggregateService, ExcelExportService, GridModule } from '@syncfusion/ej2-angular-grids';
// import { SharedModule } from '../../shared/shared.module';
import { NumericTextBoxModule, TextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { TreeGridModule } from '@syncfusion/ej2-angular-treegrid';
import { MatDividerModule } from '@angular/material/divider';
import { ReactiveFormsModule } from '@angular/forms';

import { VacationRequestsGridComponent } from './vacation-requests-grid/vacation-requests-grid.component';
import { VacationsRequestRoutingModule } from './vacations-request.routing.module';
import { OtherVacationsPopupComponent } from './vacation-requests-grid/vacation-requests-popup/other-vacations-popup/other-vacations-popup.component';
import { VrResourcesPopupComponent } from './vacation-requests-grid/vacation-requests-popup/vr-resources-popup/vr-resources-popup.component';
import { AttachmentsComponent } from 'projects/shared/src/lib/components/attachments/attachments.component';
import { HistoryComponent } from 'projects/shared/src/lib/components/history/history.component';
import { LinksComponent } from 'projects/sales/src/app/shared/components/links/links.component'
import { ColumnChooserComponent } from '../../components/column-chooser/column-chooser.component';
import { PopupHeaderComponent } from '../../components/popup-header/popup-header.component';
import { UserProfileModule } from 'projects/sales/src/app/modules/user-profile/user-profile.module';


@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FlexLayoutModule,
    VacationsRequestRoutingModule,
    MatDividerModule,
    // SharedModule,
    NumericTextBoxModule,
    DateTimePickerModule,
    DropDownListModule,
    TextBoxModule,
    DatePickerModule,
    TreeGridModule,
    GridModule,
    AttachmentsComponent,
    HistoryComponent,
    UserProfileModule,
    LinksComponent,
    ColumnChooserComponent,
    PopupHeaderComponent
  ],
  declarations: [
    VacationRequestsGridComponent,
    VacationRequestsPopupComponent,
    OtherVacationsPopupComponent,
    VrResourcesPopupComponent
  ],
  // VacationRequestService is providedIn: 'root'. Listing it here gave this lazy module its own instance, so the
  // grid filled the status list on that one while the popup (built by MatDialog from the root injector) read an empty one.
  providers: [
    ExcelExportService,
    AggregateService
  ],
  exports: [
    VacationRequestsPopupComponent,
    OtherVacationsPopupComponent,
    VrResourcesPopupComponent
  ]
})
export class VacationsRequestModule { }
